import { Content } from './Content';
import { Label } from './Label';

export default {
  Label,
  Content
};
